import { render } from "./subpartAR.vue?vue&type=template&id=2da68131"
import script from "./subpartAR.vue?vue&type=script&lang=js"
export * from "./subpartAR.vue?vue&type=script&lang=js"

import "./subpartAR.vue?vue&type=style&index=0&id=2da68131&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__